import { supabase } from './api';

export const revalidate = 0;

// Tüm kayıtları getirir
export async function getAllData() {
  const { data, error } = await supabase.from('courselesson').select();

  if (error) {
    throw new Error('Failed to fetch data');
  }

  return data;
}

// Belirli kategorideki verileri getirir (Burada 'category' yerine örneğin 'department' kullanılabilir)
export async function getDataWithCategory(category) {
  const { data, error } = await supabase
    .from('courselesson')
    .select()
    .eq('department', category)
    .order('created_at', { ascending: true }); // alternatif sıralama

  if (error) {
    throw new Error('Failed to fetch data');
  }

  return data;
}

// Belirli ID'ye göre veri getirir
export async function getIdData(id) {
  const { data, error } = await supabase.from('courselesson').select().eq('id', id);
  console.log("getIdData", id, error);

  if (error) {
    throw new Error('Failed to fetch data');
  }

  return data;
}

// Belirli öğrenciye ait verileri getirir
export async function getDataWithStudent(studentId) {
  const { data, error } = await supabase
    .from('courselesson')
    .select()
    .eq('studentId', studentId)
    .order('created_at', { ascending: false });

  if (error) {
    throw new Error('Failed to fetch data');
  }

  return data;
}

export async function getStudentIdData(id) {
  const { data, error } = await supabase.from('courselesson').select()
  .eq('studentId', id).order('lessonName', { ascending: true });
  if (error) {
    throw new Error('Failed to fetch data')
  }

  return data;
}

// Yeni kayıt ekle
export async function addData(adata) {
  const { data, error } = await supabase.from('courselesson').insert(adata).select();
  if (error) {
    console.log('addData', error);
    throw new Error('Failed to add data');
  }
  return data;
}

// Kayıt güncelle
export async function updateData(udata) {
  if (!udata.id) throw new Error('updateData: ID is required');
  console.log('udata', udata);
  const { data, error } = await supabase
    .from('courselesson')
    .update(udata)
    .eq('id', udata.id)
    .select();
  if (error) throw new Error('Failed to update data');
  return data;
}

// ID'ye göre sil
export async function deleteIdData(id) {
  const { data, error } = await supabase.from('courselesson').delete().eq('id', id);
  if (error) throw new Error('Failed to delete data');
  return data;
}
